import type React from 'react';

import type { BreadcrumbLinkProps } from './Breadcrumbs.types';

const DefaultLink: React.FC<BreadcrumbLinkProps> = ({ link, className, children, ...rest }) => (
  <a className={className} href={link} {...rest}>
    {children}
  </a>
);

const oneBased = (i: number) => i + 1;

export { DefaultLink, oneBased };
